<style>
@import '../../assets/css/tool.css';
</style>

<template>
    <div class="main-panel" v-if="ajaxLoad === true">
        <div class="main-content">
            <div class="container-fluid">
                <b-card :header="$t($route.name)">
                    <b-button variant="primary" class="mb-3 float-right" @click="getAddPayment()" v-if="permissionList.includes(permission.add)"><font-awesome-icon icon="plus"/> {{$t('setting_payment.table_add')}}</b-button>
                    <el-table class="custom-table" :data="ajaxTable" @expand-change="expandChange" @row-click="expandRow" ref="tableTest" border>
                        <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width">
                            <template slot="header">
                                <p>{{title.label}}</p>
                                <b-form-input :placeholder="title.label" @keyup.enter="initialize()" v-model="ajaxSearch[title.prop]"></b-form-input>
                            </template>
                        </el-table-column>
                        <el-table-column type="expand">
                            <b-button variant="info" size="lg" @click="getEditPayment()" v-if="permissionList.includes(permission.edit)">{{$t('setting_payment.table_edit')}}</b-button>
                            <b-button variant="danger" size="lg" class="ml-1" @click="deletePayment()" v-if="permissionList.includes(permission.delete)">{{$t('setting_payment.table_delete')}}</b-button>
                        </el-table-column>
                    </el-table>
                    <b-row class="mt-3">
                        <b-col sm="12" md="3" class="pr-0">
                            <span class="float-left">{{$t('admin.table_show_result',{result:ajaxTool.total_number})}}</span>
                        </b-col>
                        <b-col sm="12" md="9" class="pl-0">
                            <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationSizeChange" @current-change="paginationCurrentChange" :current-page.sync="ajaxTool.current_pagination" :total="ajaxTool.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                        </b-col>
                    </b-row>
                </b-card>
                
                <b-modal id="addPayment" :title="$t('setting_payment.table_add')" size="lg" @ok="addPayment" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')">
                    <form id="addPaymentForm" @submit.prevent="addPayment">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_payment.table_code')}}</template>
                            <b-form-input name="code"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_payment.table_filter')}}</template>
                            <b-form-checkbox-group name="filter[]">
                                <b-form-checkbox value="register" class="mt-2">{{$t('setting_package.table_register')}}</b-form-checkbox>
                                <b-form-checkbox value="upgrade" class="mt-2">{{$t('setting_package.table_upgrade')}}</b-form-checkbox>
                                <b-form-checkbox value="repurchase" class="mt-2">{{$t('setting_package.table_repurchase')}}</b-form-checkbox>
                                <b-form-checkbox value="maintain" class="mt-2">{{$t('setting_package.table_maintain')}}</b-form-checkbox>
                            </b-form-checkbox-group>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_payment.table_remark')}}</template>
                            <b-form-textarea name="remark"></b-form-textarea>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_payment.table_status')}}</template>
                            <b-form-checkbox name="status" size="lg" value="1" unchecked-value="0" switch></b-form-checkbox>
                        </b-form-group>

                        <b-form-group label-cols="12" label-cols-lg="4" class="mb-0">
                            <template slot="label">{{$t('setting_payment.table_radio')}}</template>
                        </b-form-group>
                        <div class="custom-from-group mb-3">
                            <b-form-group label-cols="12" label-cols-lg="4" v-for="(walletList,index) in ajaxAdd.wallet_list" :key="index" name="wallet[]">
                                <template slot="label">{{walletList.code}}</template>
                                <b-form-input :name="'formula[' + walletList.id + ']'" value="0" style="width:65%;float:left"></b-form-input>
                                <b-form-select :name="'calc_formula['+walletList.id+']'" style="width:30%;float:right" v-model="ajaxAdd.wallet_id">
                                    <option value="min">{{$t('setting_payment.table_min')}}</option>
                                    <option value="max">{{$t('setting_payment.table_max')}}</option>
                                    <option value="equal">{{$t('setting_payment.table_equal')}}</option>
                                </b-form-select>
                            </b-form-group>
                        </div>
                        <b-form-group label-cols="12" label-cols-lg="12">
                            <template slot="label">{{$t('setting_package.table_name_title')}}</template>
                            <b-tabs class="center_pane" justified fill>
                                <b-tab v-for="(lang,key) in ajaxAdd.languageList" :key="key" :title="lang.name">
                                    <b-form-group label-cols="12" label-cols-lg="4">
                                        <template slot="label">{{$t('setting_package.table_name')}}</template>
                                        <b-form-input :name="'name[' + lang.code + ']'"></b-form-input>
                                    </b-form-group>
                                </b-tab>
                            </b-tabs>
                        </b-form-group>
                    </form>
                </b-modal>
                <b-modal id="editPayment" :title="$t('setting_payment.table_edit')" size="lg" @ok="editPayment" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')">
                    <form id="editPaymentForm" @submit.prevent="editPayment">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_payment.table_code')}}</template>
                            <b-form-input name="code" v-model="ajaxEdit.code"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_payment.table_filter')}}</template>
                            <b-form-checkbox-group name="filter[]" v-model="ajaxEdit.filter">
                                <b-form-checkbox value="register" class="mt-2">{{$t('setting_package.table_register')}}</b-form-checkbox>
                                <b-form-checkbox value="upgrade" class="mt-2">{{$t('setting_package.table_upgrade')}}</b-form-checkbox>
                                <b-form-checkbox value="repurchase" class="mt-2">{{$t('setting_package.table_repurchase')}}</b-form-checkbox>
                                <b-form-checkbox value="maintain" class="mt-2">{{$t('setting_package.table_maintain')}}</b-form-checkbox>
                            </b-form-checkbox-group>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_payment.table_remark')}}</template>
                            <b-form-textarea name="remark" v-model="ajaxEdit.remark"></b-form-textarea>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_payment.table_status')}}</template>
                            <b-form-checkbox name="status" size="lg" value="1" unchecked-value="0" switch v-model="ajaxEdit.status"></b-form-checkbox>
                        </b-form-group>

                        <b-form-group label-cols="12" label-cols-lg="4" class="mb-0">
                            <template slot="label">{{$t('setting_payment.table_radio')}}</template>
                        </b-form-group>
                        <div class="custom-from-group mb-3">
                            <b-form-group label-cols="12" label-cols-lg="4" v-for="(walletList,index) in ajaxEdit.wallet_list" :key="index" name="wallet[]">
                                <template slot="label">{{walletList.code}}</template>
                                <b-form-input :name="'formula[' + walletList.id + ']'" style="width:65%;float:left" :value="walletList.value"></b-form-input>
                                <b-form-select :name="'calc_formula['+walletList.id+']'" style="width:30%;float:right" :value="walletList.calc">
                                    <option value="min">{{$t('setting_payment.table_min')}}</option>
                                    <option value="max">{{$t('setting_payment.table_max')}}</option>
                                    <option value="equal">{{$t('setting_payment.table_equal')}}</option>
                                </b-form-select>
                            </b-form-group>
                        </div>
                        <b-form-group label-cols="12" label-cols-lg="12">
                            <template slot="label">{{$t('setting_package.table_name_title')}}</template>
                            <b-tabs class="center_pane" justified fill>
                                <b-tab v-for="(lang,key) in ajaxEdit.languageList" :key="key" :title="lang.name">
                                    <b-form-group label-cols="12" label-cols-lg="4">
                                        <template slot="label">{{$t('setting_package.table_name')}}</template>
                                        <b-form-input :name="'name[' + lang.code + ']'" v-model="ajaxEdit.name[lang.code]"></b-form-input>
                                    </b-form-group>
                                </b-tab>
                            </b-tabs>
                        </b-form-group>
                    </form>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
import {languageList,paymentAjaxTable,getPaymentAdd,paymentAdd,getPaymentEdit,paymentEdit,paymentDelete,paymentCheckPackage} from '@/system/model/tools'
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';

export default {
    inject:['preloader'],
    data(){
        return{   
            ajaxLoad:false,
            validate:true,
            ajaxTable:[],
            ajaxTool:[],
            ajaxSearch:{limit:'',pagination:'',id:'',code:'',formula:'',sort:'',status:''},
            ajaxAdd:{languageList:[],wallet_list:[],wallet_id:'min'},
            ajaxEdit:{languageList:[],wallet_list:[]},
            ajaxRow:'',
            csrfName:'',
            csrfValue:'',
            csrfNameKey:'',
            csrfValueKey:'',
            pageLimit:10,
            errors: [],
            permission:{
                add:'2D8BCC',
                edit:'590733',
                delete:'8DF4F8'
            },
            permissionList:[],
            titles:[{
                prop: "id",
                label: this.$t('setting_payment.table_id'),
                width: '208'
            },{
                prop: "code",
                label: this.$t('setting_payment.table_code'),
                width: '307'
            },{
                prop: "formula",
                label: this.$t('setting_payment.table_formula'),
                width: '307'
            },{
                prop: "sort",
                label: this.$t('setting_payment.table_sort'),
                width: '307'
            },{
                prop: "status",
                label: this.$t('setting_payment.table_status'),
                width: '410'
            }], 
        }
    },methods:{
        initialize(){
            var self = this;
            var result = paymentAjaxTable(this.ajaxSearch.limit,this.ajaxSearch.pagination,this.ajaxSearch.id,this.ajaxSearch.code,this.ajaxSearch.formula,this.ajaxSearch.sort,this.ajaxSearch.status);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data.datatable.data;
                    self.ajaxTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                    self.permissionList = JSON.parse(getLocalStorage('permission_list'));
                }else{
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },getAddPayment(){
            if(this.permissionList.includes(this.permission.add)){
                var self = this;
                var result = getPaymentAdd();
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$bvModal.show('addPayment')
                        self.ajaxAdd.wallet_list = value.data.wallet_list;
                        self.ajaxAdd.languageList = value.data.language_list;   
                    }
                });
            }
        },addPayment(){
            if(this.permissionList.includes(this.permission.add)){
                var self = this;
                this.preloader(true);
                this.errors = [];
                if(this.validate){
                    var form = document.getElementById('addPaymentForm');
                    var formData = new FormData(form);
                    formData.append(this.csrfNameKey, this.csrfName); 
                    formData.append(this.csrfValueKey, this.csrfValue);  
                    var result = paymentAdd(formData);
                    result.then(function(value){
                        self.preloader(false);
                        if(value.valid){
                            self.$swal.fire({
                                type: 'success',
                                text: self.$t(value.returnMsg),
                                onClose: () => {
                                    self.initialize();            
                                }
                            });
                        }else{
                            var text = "";
                            if(Array.isArray(value.returnMsg)){
                                value.returnMsg.forEach(function (value) {
                                    text += self.$t(value)+"<br />";
                                }); 
                            }else{
                                text = self.$t(value.returnMsg);
                            }

                            self.$swal.fire({
                                type: 'error',
                                html: text,
                                onClose: () => {
                                    self.initialize();            
                                }
                            });
                        }
                    });    
                }else{
                    this.validate = true;
                    this.preloader(false);
                    var text = "";
                    this.errors.forEach(function (value) {
                        text += self.$t(value)+"<br />";
                    }); 
                    
                    this.$swal.fire({
                        type: 'error',
                        html: text
                    });
                }        
            } 
        },getEditPayment(){
            if(this.permissionList.includes(this.permission.edit)){
                var self = this;
                var result = getPaymentEdit(this.ajaxRow);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$bvModal.show('editPayment');
                        self.ajaxEdit = value.data.this_detail;
                        self.ajaxEdit.wallet_list = value.data.wallet_list;
                        self.ajaxEdit.languageList = value.data.language_list;   
                    }else{
                        var text = "";
                        self.errors.forEach(function (value) {
                            text += self.$t(value)+"<br />";
                        }); 
                        
                        self.$swal.fire({
                            type: 'error',
                            html: text
                        });
                    }
                })
            }
        },editPayment(){
            if(this.permissionList.includes(this.permission.edit)){
                var self = this;
                this.preloader(true);
                if(this.validate){
                    var form = document.getElementById('editPaymentForm');
                    var formData = new FormData(form);
                    formData.append(this.csrfNameKey, this.csrfName); 
                    formData.append(this.csrfValueKey, this.csrfValue); 
                    formData.append('id', this.ajaxEdit.id); 
                    var result = paymentEdit(formData);
                    result.then(function(value){
                        self.preloader(false);
                        if(value.valid){
                            self.$swal.fire({
                                type: 'success',
                                text: self.$t(value.returnMsg),
                                onClose: () => {
                                    self.initialize();            
                                }
                            });
                        }else{
                            var text = "";
                            if(Array.isArray(value.returnMsg)){
                                value.returnMsg.forEach(function (value) {
                                    text += self.$t(value)+"<br />";
                                }); 
                            }else{
                                text = self.$t(value.returnMsg);
                            }

                            self.$swal.fire({
                                type: 'error',
                                html: text,
                                onClose: () => {
                                    self.initialize();            
                                }
                            });
                        }
                    })
                }else{
                    this.validate = true;
                    this.preloader(false);
                    var text = "";
                    this.errors.forEach(function (value) {
                        text += self.$t(value)+"<br />";
                    }); 
                
                    this.$swal.fire({
                        type: 'error',
                        html: text
                    });
                } 
            }
        },deletePayment(){
            if(this.permissionList.includes(this.permission.delete)){
                this.$swal.fire({
                text: this.$t('msg.confirm_delete'),
                type: 'info',
                showCancelButton: true,
                confirmButtonText: this.$t('button.confirm'),
                cancelButtonText: this.$t('button.cancel'),
                }).then((result)=>{
                    if(result.value){
                        var self = this;
                        self.preloader(true);
                        var formData = new FormData();
                        formData.append(this.csrfNameKey, this.csrfName); 
                        formData.append(this.csrfValueKey, this.csrfValue); 
                        formData.append('id', this.ajaxRow); 
                        var result = paymentDelete(formData);		
                        result.then(function(value){
                            self.preloader(false);
                            if(value.valid){
                                self.$swal.fire({
                                    type: 'success',
                                    text: self.$t(value.returnMsg),
                                    onClose: () => {
                                        self.initialize();            
                                    }
                                });
                            }else{
                                self.preloader(false);
                                var text = "";
                                if(Array.isArray(value.returnMsg)){
                                    value.returnMsg.forEach(function (value) {
                                        text += self.$t(value)+"<br />";
                                    }); 
                                }else{
                                    text = self.$t(value.returnMsg);
                                }

                                self.$swal.fire({
                                    type: 'error',
                                    html: text,
                                    onClose: () => {
                                        self.initialize();            
                                    }
                                });
                            }
                        });
                    }
                });
            }
        },expandRow(row){
            this.$refs.tableTest.toggleRowExpansion(row);
            this.ajaxRow = row.id
        },expandChange(row,expandedRows){
            if(expandedRows.length>1){
                expandedRows.shift()
            }
        },paginationSizeChange(limit){
            this.ajaxSearch.limit = limit;
            this.initialize();
        },paginationCurrentChange(pagination){
            this.ajaxSearch.pagination = pagination;
            this.initialize();
        }
    },created(){
        this.preloader(false);
        this.initialize();
    }
}
</script>
